import { Component, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { StoreGroupResolverResolver } from '../../shared/services/resolver/store-group-resolver.resolver';
import { StoreDetailService } from '../../shared/services/resolver/store-detail.service';
import { StateService } from '../../shared/services/storage/state.service';
import { Observable, of } from 'rxjs';
import { InfiniteScrollProviderComponent } from '../../shared/components/infinite-scroll-provider/infinite-scroll-provider.component';
import { NavigationComponent } from '../navigation/navigation.component';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { MobileNavigationComponent } from '../mobile-navigation/mobile-navigation.component';
import { AsyncPipe, isPlatformBrowser } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogClose } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-wrapper',
    templateUrl: './wrapper.component.html',
    styleUrls: ['./wrapper.component.scss'],
    standalone: true,
    imports: [TranslatePipe, InfiniteScrollProviderComponent, NavigationComponent, RouterOutlet, FooterComponent, MobileNavigationComponent, MatButtonModule, MatDialogClose, AsyncPipe]
})
export class WrapperComponent implements OnInit {
  private storeGroupResolver = inject(StoreGroupResolverResolver);
  private storeDetailResolver = inject(StoreDetailService);
  private stateService = inject(StateService);
  private route = inject(ActivatedRoute);
  private platformId = inject(PLATFORM_ID);
  storeDetail: any;
  storeGroups: any;
  storeGroupData: any;
  isClubMember: Observable<boolean>;
  isLoggedIn: Observable<boolean>;

  ngOnInit(): void {
    this.getStoreDetail();
    this.getStoreGroups();
    this.isClubMember = isPlatformBrowser(this.platformId) ? this.stateService.getClubMembershipState() : of(false);
    this.isLoggedIn = this.stateService.getLoginStatus();
  }

  getStoreDetail() {
    this.storeDetail = this.storeDetailResolver.permissionInit;
  }

  getStoreGroups() {
    this.storeGroups = this.storeGroupResolver.permissionInit?.stores_detail;
  }
}
